import { render, staticRenderFns } from "./info-user.vue?vue&type=template&id=45a1b5dc&scoped=true&"
import script from "./info-user.vue?vue&type=script&lang=js&"
export * from "./info-user.vue?vue&type=script&lang=js&"
import style0 from "./info-user.vue?vue&type=style&index=0&id=45a1b5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a1b5dc",
  null
  
)

export default component.exports